import { render } from "./VulnerableBenefits.vue?vue&type=template&id=e0c2464c&scoped=true"
import script from "./VulnerableBenefits.vue?vue&type=script&lang=js"
export * from "./VulnerableBenefits.vue?vue&type=script&lang=js"

import "./VulnerableBenefits.vue?vue&type=style&index=0&id=e0c2464c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c2464c"]])

export default __exports__